import { baseURL } from '@/pinia/general/uri';

export default class Uri {
  baseURL: string = baseURL;
  env: string = 'env';
  i18n: string = 'i18n';

  getUserManager: string = 'user/manager';
  updateSchema: string = 'updateschema';
  getSchema: string = 'designschema';
  color: string = 'system/color';
  user: string = 'user';
  log: string = 'log';
  error: string = 'log/error';

  bankMaterialsAll: string = 'bank-materials/all';
  bankMaterialsId(id: string): string {
    return `bank-materials/${id}`;
  }
  smsCode: string = 'session/sms-code';
  emailCode: string = 'session/email-code';
  registration: string = 'session/registration';
  login: string = 'session/login';
  loginAgent: string = 'login-agent';
  logout: string = 'session/logout';
  app: string = 'application';
  apps: string = 'applications';
  searchOrg: string = 'searchDadataOrg';
  searchAddr: string = 'suggest/address';
  searchCountry: string = 'suggest/country';
  version: string = 'version';
  createApplicationByPhysicalEntity = 'application/physical-entity';

  appById(id: string): string {
    return `${this.app}/${id}`;
  }
  form(id: string): string {
    return `${this.app}/${id}/form`;
  }

  // Перенесен в сервис step2 postBlankForm и getBlankForm
  blankForm(id: string): string {
    return `${this.app}/blank-form/${id}`;
  }
  blankFormStep1(id: string): string {
    return `${this.app}/blank-form/first-step/${id}`;
  }
  updateForm(id: string): string {
    return `${this.app}/${id}/update-form`;
  }
  annul(id: string): string {
    return `${this.app}/${id}/annul`;
  }
  save(id: string): string {
    return `${this.app}/update/${id}`;
  }
  status(id: string): string {
    return `${this.app}/${id}/status`;
  }
  recognitionPassport(id: string): string {
    return `${this.app}/${id ? id + '/' : ''}scanning/passport`;
  }
  participantOfApp(appId: string): string {
    return `${this.app}/${appId}/participant`;
  } //Get all the invididuals of application

  // deleteParticipant(appId:string, participantId:string):string { return `${this.app}/${appId}/participant/${participantId}`; };

  documents(id: string): string {
    return `${this.app}/${id}/client-documents`;
  }
  document(id: string): string {
    return `${this.app}/${id}/add-document`;
  }
  // Перенесен в сервис step4 fetchTableDocuments
  documentsTableStep4(id: string): string {
    return `all-documents/${id}`;
  }
  addDocRequirement(reqId: string): string {
    return `${this.app}/document-requirement/${reqId}/add-document`;
  }
  addDigitalDocument(appId: string): string {
    return `${this.app}/${appId}/add-digital-document`;
  }
  downloadR: string = 'applications/download';

  decision(id: string): string {
    return `${this.app}/${id}/decision`;
  }

  applicationSignBinary(uuids: string): string {
    return 'application/' + uuids + '/sign';
  }
  urlSigning(appId: string, signatoryId: string, accessToken: string) {
    return (fileId: string) => `signatory/${fileId}/sign/${appId}/${signatoryId}?accessToken=${accessToken}`;
  }
  urlPep(appId: string, signatoryId: string, accessToken: string) {
    return `signatory/sign-pep/${appId}/${signatoryId}?accessToken=${accessToken}`;
  }

  // pepOffert: string = 'sign-pep';

  downloadFileForSignatoryV2(appId: string, signatoryId: string, accessToken: string) {
    return (fileId: string) =>
      `/signatory/download-file-v2/${fileId}/${appId}/${signatoryId}?accessToken=${accessToken}`;
  }
  downloadFileForSignatory(appId: string, signatoryId: string, accessToken: string) {
    return (fileId: string) => `/signatory/download-file/${fileId}/${appId}/${signatoryId}?accessToken=${accessToken}`;
  }
  downloadSignature(appId: String, signId: String, accessToken: string) {
    return `/signatory/download/${appId}/${signId}?accessToken=${accessToken}`;
  }
  // urlUploadPepForSignatory(appId: string, signatoryId: string, accessToken: string) {
  //   return `/signatory/application/add-documents/${appId}/${signatoryId}?accessToken=${accessToken}`;
  // }
  downloadDefaultSignature: string = '/signature';
  downloadFileDocument(docId: string) {
    return 'file-download/' + docId;
  }
  generateDockLkk(appId: string): string {
    return 'document-download/' + appId;
  }
  download(id: string, docId: string): string {
    return `${this.app}/${id}/document/${docId}/download`;
  }
  // electronic docs
  electronicGenerate(appId: string): string {
    return `electronic-document/${appId}/generate`;
  }
  metadataResultByTemplateId(appId: string, templateId: string): string {
    return `electronic-document/${appId}/${templateId}/metadata`;
  }

  electronicGenerateMetaData(appId: string): string {
    return `electronic-document/${appId}/generate-metadata`;
  }

  electronicSaveMetaData(appId: string, fileId: String): string {
    return `electronic-document/${appId}/save-metadata/${fileId}`;
  }

  electronicSaveMetaDataByFileid(appId: string, fileId: String): string {
    return `electronic-document/${appId}/metadata/${fileId}`;
  }

  downloadDocumentTemplate(templateId: string): string {
    return `electronic-document/${this.app}/template-for-request/${templateId}`;
  }

  // step-4
  downloadFile(fileId: string) {
    return `/application/download-document-on-step-4/${fileId}`;
  }

  nextStatus(id: string): string {
    return `${this.app}/${id}/status/next`;
  }
  meta(id: string): string {
    return `${this.app}/${id}/meta`;
  }
  // Перенесен в сервис step2 fetchBankOffices
  bankOffices: string = 'bankoffices';

  // Перенесен в сервис step2 getNewQuestionnaire
  questionnaire(id: string, idN: string): string {
    return `${this.app}/${id}/questionnaire-new?${idN}`;
  }
  validateCaptcha: string = 'captcha';

  resetClient(id: string): string {
    return `${this.app}/reset-client/${id}`;
  }

  ws: string = 'ws';
  applicationResetClient: string = 'application/reset-client';
  marketing: string = 'marketing';

  logoLoginImg: string = this.baseURL + 'image/LOGIN_LOGO_LKK';
  headerLogoImage: string = this.baseURL + 'image/UPPER_MENU_LOGO_LKK';
  navbarImg: string = this.baseURL + 'image/NAVBAR';
  bgImg: string = this.baseURL + 'image/BG_MAIN_IMAGE_LKK';
  headerImg: string = this.baseURL + 'image/HEADER';

  signatory(appId: string, signatoryId: string): string {
    return `signatory/${appId}/${signatoryId}`;
  }
  signatoryBank(appId: string, signatoryId: string): string {
    return `signatory/${appId}/bank/${signatoryId}`;
  }
  signedDocTypes(appId: string): string {
    return `generate-docs/${appId}/signed-doc-type`;
  }
  participantSignatories(appId: string): string {
    return `generate-docs/${appId}/signed-participant `;
  }
  dynamicDictionary(appId: string): string {
    return `generate-docs/${appId}/value-dictionary`;
  }
  generateDocs(appId: string): string {
    return `generate-docs/${appId}/form `;
  }
  bankSignatoriesByOfficeId(officeId: string): string {
    return `users/signed-bank/${officeId}`;
  }
  signPepOffer: string = 'sign-pep-offer';
  // signPep: string = 'sign-pep'

  documentTypeMchd(appId: string): string {
    return `document-type/mchd/${appId}`;
  }

  mchd(appId: string, certId: string): string {
    return `mchd/${certId}/${appId}`;
  }

  mchdToken(certId: string, appId: string, signId: string, accessToken: string): string {
    return `signatory/mchd/${certId}/${appId}/${signId}?accessToken=${accessToken}`;
  }

  documentTypeMchdRef(appId: string, signId: string, accessToken: string): string {
    return `signatory/document-type/mchd/${appId}/${signId}?accessToken=${accessToken}`;
  }

  getMchdId(appId: string, certId: string): string {
    return `document-type/mchd/${certId}/${appId}`;
  }
  getMchdIdToken(certId: string, appId: string, signId: string, accessToken: string): string {
    return `signatory/document-type/mchd/${certId}/${appId}/${signId}?accessToken=${accessToken}`;
  }

  signatoryPepSmsCode(appId: string, signId: string, accessToken: string): string {
    return `/signatory/session/pep/sms-code/${appId}/${signId}?accessToken=${accessToken}`;
  }

  applicationsCount: string = 'applications/count';

  collaboraGetToken(fileId: string): string {
    return `wopi/token/${fileId}`;
  }
}

export const uri = new Uri();
